// This file is AUTOGENERATED, do not edit it manually!!!

export const customFields = {
    text_currentIdentity: 'Valore di inizializzazione',
    text_delete: 'Cancellare il campo',
    text_edit: 'Modificare il campo',
    text_filter: 'Campi personalizzati per',
    text_include_in_unportfolioed_projects: 'Includere tra quelli non compresi nel portfolio',
    text_isIdentity: 'Incremento automatico',
    text_isNumeric: 'Non mostrare decimali',
    text_isRequired: 'E\' obbligatorio',
    text_restricted_by_portfolio: 'Ristretto dal portfolio',
};
